import React from 'react';
import {
} from 'material-ui';
import {
  translate as t,
} from 'admin-on-rest';
import TextRecord from '../FormInputs/TextRecord';
import ImageInput from '../FormInputs/ImageInput';
import GalleryInput from '../FormInputs/GalleryInput';

export const IMAGE_SELECT_TYPE = 'chooseimage';
export const defaultImageSelect = () => {
  const randomInteger = Math.floor(Math.random() * 1000);
  const now = new Date().getTime();
  return {
    id: `${now}${randomInteger}`,
    type: IMAGE_SELECT_TYPE,
  };
};

const TRANSLATION_PREFIX = 'resources.quizes.fields.questions';
const TRANSLATION_QUIZ_PREFIX = 'resources.quizes.questions';

const STYLES = {
  noTopMargin: {
    marginTop: 0,
  },
  noBottomMargin: {
    marginBottom: 0,
  },
  hintColor: {
    color: 'rgba(0, 0, 0, 0.3)',
  },
};

class ImageSelectForm extends React.Component {
  optionsOnChange = (files) => {
    this.change('options', files);
  }
  readCorrect = () => {
    const { correct } = this.props;
    // In this case "correct" is set with a previously uploaded value
    if (typeof correct === 'string') {
      return correct;
    // Or it needs to be derived after upload
    } else if (correct && correct.temporaryValue) {
      return correct.temporaryValue;
    }
    // Or not yet set
    return undefined;
  }
  correctOnChange = (correct) => {
    const optionsIdx = this.props.options.findIndex((opt) => {
      if (typeof opt === 'string') {
        return opt === correct;
      }
      return opt.src === correct;
    });

    this.change('correct', {
      derivedFrom: `${this.props.path}.options.${optionsIdx}`,
      temporaryValue: correct,
    });
  }
  change = (key, value) => {
    const delta = {};
    delta[key] = value;
    this.props.onChange(delta, this.props.id);
  }

  render() {
    const {
      path, options,
      translate,
    } = this.props;

    const selections = (options || []).map((img) => {
      if (img.src) {
        return {
          key: img.src,
          src: img.src,
        };
      }
      return {
        key: img,
        src: img,
      };
    });

    return (
      <>
        <TextRecord
          label={translate(`${TRANSLATION_PREFIX}.type`)}
          value={translate(`${TRANSLATION_QUIZ_PREFIX}.imageSelect`)}
        />
        <br />
        <h4 style={STYLES.noBottomMargin}>{translate(`${TRANSLATION_PREFIX}.options`)}</h4>
        <p style={{ ...STYLES.noTopMargin, ...STYLES.hintColor }}>
          {translate(`${TRANSLATION_QUIZ_PREFIX}.imageSelect.optionsHint`)}
        </p>
        <ImageInput
          source={`${path}.options`}
          onlyUrl
          multiple
        />
        <br />
        <h4 style={STYLES.noBottomMargin}>{translate(`${TRANSLATION_PREFIX}.correct`)}</h4>
        <p style={{ ...STYLES.noTopMargin, ...STYLES.hintColor }}>
          {translate(`${TRANSLATION_QUIZ_PREFIX}.imageSelect.correctHint`)}
        </p>
        <GalleryInput
          titleIfSelected={translate(`${TRANSLATION_QUIZ_PREFIX}.imageSelect.selectedTitle`)}
          subTitleIfSelected={translate(`${TRANSLATION_QUIZ_PREFIX}.imageSelect.selectedSubtitle`)}
          onSelect={this.correctOnChange}
          selections={selections}
          selected={this.readCorrect()}
        />
      </>
    );
  }
}

export default t(ImageSelectForm);
